// Form Constants
export const ERROR_MESSAGES = {
  SIGN_IN_REQUIRED: 'Sign in required.',
  FORM_CANNOT_BE_LOADED: 'Form cannot be loaded.',
  FORM_ACCESS_ERROR: 'Access error.',
  SESSION_ALREADY_SUBMITTED_ERROR: 'Session has already been submitted.',
  SESSION_TERMINATED_ERROR: 'Session has been terminated.',
  FORM_UNAVAILABLE_ERROR: 'Component is unavailable.',
  REQUIRED_FIELD: 'is a required field',
  REQUIRED_QUESTION: 'This question is required',
  REQUIRED_FIELD_TABLE: 'is required',
  FORM_SUBMISSION_ERROR: 'There was an error submitting the form',
};

export const ANSWER_TYPES = {
  CALENDAR_ANSWER: 'calendar_answer',
  TABLE_ANSWER: 'table_answer',
  REPEATABLE_SECTION_ANSWER: 'repeatable_sections_answer',
};

export const UNIQUE_NAMES_GENERATOR_CONFIG = {
  dictionaries: ['colors', 'animals'],
  separator: ' ',
  style: 'capital',
  length: 2,
};

export const COMPONENT_FORMATS = {
  // v1 type names
  MULTIPLE_CHOICE: 'multiple_choice',
  SINGLE_CHOICE: 'single_choice',
  SINGLE_SELECT: 'single_select',
  FREE_TEXT: 'free_text',
  ROW_TEXT: 'row_text',
  SINGLE_LINE_TEXT: 'single_line_text',
  NUMBER_INPUT: 'number_input',
  CALENDAR: 'calendar',
  TABLE: 'table',
  UPLOAD_MEDIA: 'upload_media',
  VIDEO_EMBED: 'video_embed',
  DRAWABLE_MAP: 'drawable_map',
  ESIGNATURE: 'esignature',
  FILE_PREVIEW: 'file_preview',
  RICH_TEXT_EDITOR: 'rich_text_editor',
  REPEATABLE_SECTIONS: 'repeatable_sections',
  DATABASE_CONTENT: 'database_content',
  // v2 type names
  CHECKBOX: 'checkbox',
  RADIO_BUTTON: 'radio_button',
  DROPDOWN: 'dropdown',
  LONG_TEXT: 'long_text',
  SHORT_TEXT: 'short_text',
  NUMBER: 'number',
  LIST: 'list',
  DATE: 'date',
  FILE_UPLOAD: 'file_upload',
  MAP: 'map',
  SIGNATURE: 'signature',
  RICH_TEXT: 'rich_text',
  IMAGE_ANNOTATION: 'image_annotation',
  ADDRESS: 'address',
  REPEATABLE_SECTION: 'repeatable_section',
};

export const AUTH_STATES = {
  LOADING: 'loading',
  SIGNED_IN: 'signedIn',
  SIGNED_OUT: 'signedOut',
};

export const RECEIPT_STATES = {
  HIDDEN: 'hidden',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const DEFAULT_TIMEZONE = 'UTC';

export const FORM_TYPES = {
  STANDARD: 'standard',
  TEST: 'test',
  PREVIEW: 'preview',
};

// API Endpoints
export const API_ENDPOINTS = {
  TEST_FORM_SESSION: '/test_form_session/',
  FORM_SESSION: '/form_session',
  TEST_RESULT_WITH_SESSION_ID: '/test_result_with_session_id',
  FORM_META: '/form_meta',
  SAVE_TASK_LOADED: '/save_task_loaded',
};

// Default Values
export const DEFAULT_VALUES = {
  ANONYMOUS_USERNAME: 'Anonymous',
  UNTITLED_FORM: 'Untitled',
  APP_NAME: 'Workflow86',
  DEFAULT_PAGE_TITLE: 'Page',
  DELETE_PLACEHOLDER: 'DELETE',
};

// UI Text Constants
export const UI_TEXT = {
  SAVE_BUTTON: 'Save',
  SAVE_TEST_VALUES: 'Save Test Values',
  LAST_SAVED_PREFIX: 'Last saved',
  AUTO_SAVE_TOOLTIP: 'Your work is auto-saved',
  FORM_TERMINATED_MESSAGE:
    'This form has been terminated and cannot be submitted',
  FORM_READONLY_MESSAGE:
    'This form has already been submitted and is read only',
  PREVIEW_MODE_MESSAGE: 'This is a form preview and cannot be submitted',
};

// Size Constants
export const SIZE_CONSTANTS = {
  CIRCULAR_PROGRESS_LARGE: 50,
  CIRCULAR_PROGRESS_SMALL: 20,
  DEFAULT_FORM_LENGTH: 1,
};

// Query Parameters
export const QUERY_PARAMS = {
  IS_LATEST_DRAFT: '&isLatestDraft=true',
  INCLUDE_SINGLE_USE_FORM: '&includeSingleUseForm=',
  PROJECT_VERSION: '&projectVersion=',
  SESSION_ID: '&session_id=',
  IS_TEST: '&isTest=',
  PROJECT_SESSION_ID: '&projectSessionId=',
  THREAD_ID: '&threadId=',
  SUBMISSION_ID: '&submissionId=',
};
